"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadIcon = exports.IconImports = void 0;
const react_1 = __importDefault(require("react"));
exports.IconImports = {
    "address-book": () => import("./iconAssets/address-book.js"),
    "airplane-in-flight": () => import("./iconAssets/airplane-in-flight.js"),
    "airplane-landing": () => import("./iconAssets/airplane-landing.js"),
    "airplane-takeoff": () => import("./iconAssets/airplane-takeoff.js"),
    "airplane-tilt": () => import("./iconAssets/airplane-tilt.js"),
    alarm: () => import("./iconAssets/alarm.js"),
    anchor: () => import("./iconAssets/anchor.js"),
    archive: () => import("./iconAssets/archive.js"),
    "arrow-circle-down-left": () => import("./iconAssets/arrow-circle-down-left.js"),
    "arrow-circle-down-right": () => import("./iconAssets/arrow-circle-down-right.js"),
    "arrow-circle-down": () => import("./iconAssets/arrow-circle-down.js"),
    "arrow-circle-left": () => import("./iconAssets/arrow-circle-left.js"),
    "arrow-circle-right": () => import("./iconAssets/arrow-circle-right.js"),
    "arrow-circle-up-left": () => import("./iconAssets/arrow-circle-up-left.js"),
    "arrow-circle-up-right": () => import("./iconAssets/arrow-circle-up-right.js"),
    "arrow-circle-up": () => import("./iconAssets/arrow-circle-up.js"),
    "arrow-counter-clockwise": () => import("./iconAssets/arrow-counter-clockwise.js"),
    "arrow-down-left": () => import("./iconAssets/arrow-down-left.js"),
    "arrow-down-right": () => import("./iconAssets/arrow-down-right.js"),
    "arrow-down": () => import("./iconAssets/arrow-down.js"),
    "arrow-fat-down": () => import("./iconAssets/arrow-fat-down.js"),
    "arrow-fat-left": () => import("./iconAssets/arrow-fat-left.js"),
    "arrow-fat-right": () => import("./iconAssets/arrow-fat-right.js"),
    "arrow-fat-up": () => import("./iconAssets/arrow-fat-up.js"),
    "arrow-left": () => import("./iconAssets/arrow-left.js"),
    "arrow-line-down": () => import("./iconAssets/arrow-line-down.js"),
    "arrow-line-left": () => import("./iconAssets/arrow-line-left.js"),
    "arrow-line-right": () => import("./iconAssets/arrow-line-right.js"),
    "arrow-right": () => import("./iconAssets/arrow-right.js"),
    "arrow-square-in": () => import("./iconAssets/arrow-square-in.js"),
    "arrow-square-out": () => import("./iconAssets/arrow-square-out.js"),
    "arrow-up-left": () => import("./iconAssets/arrow-up-left.js"),
    "arrow-up-right": () => import("./iconAssets/arrow-up-right.js"),
    "arrow-up": () => import("./iconAssets/arrow-up.js"),
    "arrows-clockwise": () => import("./iconAssets/arrows-clockwise.js"),
    "arrows-down-up": () => import("./iconAssets/arrows-down-up.js"),
    "arrows-in-cardinal": () => import("./iconAssets/arrows-in-cardinal.js"),
    "arrows-in-line-vertical": () => import("./iconAssets/arrows-in-line-vertical.js"),
    "arrows-in-simple": () => import("./iconAssets/arrows-in-simple.js"),
    "arrows-in": () => import("./iconAssets/arrows-in.js"),
    "arrows-out-cardinal": () => import("./iconAssets/arrows-out-cardinal.js"),
    "arrows-out-simple": () => import("./iconAssets/arrows-out-simple.js"),
    "arrows-out": () => import("./iconAssets/arrows-out.js"),
    article: () => import("./iconAssets/article.js"),
    "bell-ringing": () => import("./iconAssets/bell-ringing.js"),
    "bell-slash": () => import("./iconAssets/bell-slash.js"),
    "bell-z": () => import("./iconAssets/bell-z.js"),
    bell: () => import("./iconAssets/bell.js"),
    bookmark: () => import("./iconAssets/bookmark.js"),
    browser: () => import("./iconAssets/browser.js"),
    browsers: () => import("./iconAssets/browsers.js"),
    buildings: () => import("./iconAssets/buildings.js"),
    calculator: () => import("./iconAssets/calculator.js"),
    "calendar-blank": () => import("./iconAssets/calendar-blank.js"),
    "calendar-check": () => import("./iconAssets/calendar-check.js"),
    "calendar-plus": () => import("./iconAssets/calendar-plus.js"),
    "calendar-x": () => import("./iconAssets/calendar-x.js"),
    calendar: () => import("./iconAssets/calendar.js"),
    "camera-plus": () => import("./iconAssets/camera-plus.js"),
    "camera-slash": () => import("./iconAssets/camera-slash.js"),
    camera: () => import("./iconAssets/camera.js"),
    cards: () => import("./iconAssets/cards.js"),
    "caret-circle-down": () => import("./iconAssets/caret-circle-down.js"),
    "caret-circle-left": () => import("./iconAssets/caret-circle-left.js"),
    "caret-circle-right": () => import("./iconAssets/caret-circle-right.js"),
    "caret-circle-up": () => import("./iconAssets/caret-circle-up.js"),
    "caret-double-down": () => import("./iconAssets/caret-double-down.js"),
    "caret-double-left": () => import("./iconAssets/caret-double-left.js"),
    "caret-double-right": () => import("./iconAssets/caret-double-right.js"),
    "caret-double-up": () => import("./iconAssets/caret-double-up.js"),
    "caret-down": () => import("./iconAssets/caret-down.js"),
    "caret-left": () => import("./iconAssets/caret-left.js"),
    "caret-right": () => import("./iconAssets/caret-right.js"),
    "caret-up-down": () => import("./iconAssets/caret-up-down.js"),
    "caret-up": () => import("./iconAssets/caret-up.js"),
    "chart-bar-horizontal": () => import("./iconAssets/chart-bar-horizontal.js"),
    "chart-bar": () => import("./iconAssets/chart-bar.js"),
    "chart-donut": () => import("./iconAssets/chart-donut.js"),
    "chart-line-down": () => import("./iconAssets/chart-line-down.js"),
    "chart-line-up": () => import("./iconAssets/chart-line-up.js"),
    "chart-line": () => import("./iconAssets/chart-line.js"),
    "chart-pie-slice": () => import("./iconAssets/chart-pie-slice.js"),
    "chart-pie": () => import("./iconAssets/chart-pie.js"),
    "chat-circle": () => import("./iconAssets/chat-circle.js"),
    "chats-circle": () => import("./iconAssets/chats-circle.js"),
    "check-circle": () => import("./iconAssets/check-circle.js"),
    "check-fat": () => import("./iconAssets/check-fat.js"),
    "check-square-offset": () => import("./iconAssets/check-square-offset.js"),
    "check-square": () => import("./iconAssets/check-square.js"),
    check: () => import("./iconAssets/check.js"),
    checks: () => import("./iconAssets/checks.js"),
    "clock-afternoon": () => import("./iconAssets/clock-afternoon.js"),
    "clock-counter-clockwise": () => import("./iconAssets/clock-counter-clockwise.js"),
    clock: () => import("./iconAssets/clock.js"),
    "closed-captioning": () => import("./iconAssets/closed-captioning.js"),
    "cloud-arrow-up": () => import("./iconAssets/cloud-arrow-up.js"),
    code: () => import("./iconAssets/code.js"),
    coin: () => import("./iconAssets/coin.js"),
    coins: () => import("./iconAssets/coins.js"),
    copy: () => import("./iconAssets/copy.js"),
    "credit-card": () => import("./iconAssets/credit-card.js"),
    cursor: () => import("./iconAssets/cursor.js"),
    dna: () => import("./iconAssets/dna.js"),
    "dot-outline": () => import("./iconAssets/dot-outline.js"),
    dot: () => import("./iconAssets/dot.js"),
    "dots-nine": () => import("./iconAssets/dots-nine.js"),
    "dots-three-circle-vertical": () => import("./iconAssets/dots-three-circle-vertical.js"),
    "dots-three-circle": () => import("./iconAssets/dots-three-circle.js"),
    "dots-three-outline-vertical": () => import("./iconAssets/dots-three-outline-vertical.js"),
    "dots-three-outline": () => import("./iconAssets/dots-three-outline.js"),
    "dots-three-vertical": () => import("./iconAssets/dots-three-vertical.js"),
    "dots-three": () => import("./iconAssets/dots-three.js"),
    "download-simple": () => import("./iconAssets/download-simple.js"),
    "envelope-simple-open": () => import("./iconAssets/envelope-simple-open.js"),
    "envelope-simple": () => import("./iconAssets/envelope-simple.js"),
    export: () => import("./iconAssets/export.js"),
    "eye-slash": () => import("./iconAssets/eye-slash.js"),
    eye: () => import("./iconAssets/eye.js"),
    "face-mask": () => import("./iconAssets/face-mask.js"),
    factory: () => import("./iconAssets/factory.js"),
    "file-arrow-down": () => import("./iconAssets/file-arrow-down.js"),
    "file-image": () => import("./iconAssets/file-image.js"),
    "file-pdf": () => import("./iconAssets/file-pdf.js"),
    "file-video": () => import("./iconAssets/file-video.js"),
    file: () => import("./iconAssets/file.js"),
    files: () => import("./iconAssets/files.js"),
    "fingerprint-simple": () => import("./iconAssets/fingerprint-simple.js"),
    "first-aid": () => import("./iconAssets/first-aid.js"),
    flag: () => import("./iconAssets/flag.js"),
    flask: () => import("./iconAssets/flask.js"),
    "folder-open": () => import("./iconAssets/folder-open.js"),
    folder: () => import("./iconAssets/folder.js"),
    funnel: () => import("./iconAssets/funnel.js"),
    gear: () => import("./iconAssets/gear.js"),
    globe: () => import("./iconAssets/globe.js"),
    "grid-four": () => import("./iconAssets/grid-four.js"),
    "grid-nine": () => import("./iconAssets/grid-nine.js"),
    "hand-pointing": () => import("./iconAssets/hand-pointing.js"),
    hand: () => import("./iconAssets/hand.js"),
    "hard-drive": () => import("./iconAssets/hard-drive.js"),
    "hard-drives": () => import("./iconAssets/hard-drives.js"),
    headphones: () => import("./iconAssets/headphones.js"),
    headset: () => import("./iconAssets/headset.js"),
    heart: () => import("./iconAssets/heart.js"),
    hospital: () => import("./iconAssets/hospital.js"),
    house: () => import("./iconAssets/house.js"),
    "identification-badge": () => import("./iconAssets/identification-badge.js"),
    "identification-card": () => import("./iconAssets/identification-card.js"),
    image: () => import("./iconAssets/image.js"),
    images: () => import("./iconAssets/images.js"),
    info: () => import("./iconAssets/info.js"),
    layout: () => import("./iconAssets/layout.js"),
    lightning: () => import("./iconAssets/lightning.js"),
    "link-break": () => import("./iconAssets/link-break.js"),
    link: () => import("./iconAssets/link.js"),
    "list-bullets": () => import("./iconAssets/list-bullets.js"),
    "list-checks": () => import("./iconAssets/list-checks.js"),
    list: () => import("./iconAssets/list.js"),
    "lock-simple-open": () => import("./iconAssets/lock-simple-open.js"),
    "lock-simple": () => import("./iconAssets/lock-simple.js"),
    "logo-apple": () => import("./iconAssets/logo-apple.js"),
    "logo-facebook": () => import("./iconAssets/logo-facebook.js"),
    "logo-google": () => import("./iconAssets/logo-google.js"),
    "logo-instagram": () => import("./iconAssets/logo-instagram.js"),
    "logo-linkedin": () => import("./iconAssets/logo-linkedin.js"),
    "logo-microsoft": () => import("./iconAssets/logo-microsoft.js"),
    "logo-x": () => import("./iconAssets/logo-x.js"),
    "logo-yahoo": () => import("./iconAssets/logo-yahoo.js"),
    "magnifying-glass-minus": () => import("./iconAssets/magnifying-glass-minus.js"),
    "magnifying-glass-plus": () => import("./iconAssets/magnifying-glass-plus.js"),
    "magnifying-glass": () => import("./iconAssets/magnifying-glass.js"),
    "map-pin": () => import("./iconAssets/map-pin.js"),
    "map-trifold": () => import("./iconAssets/map-trifold.js"),
    "microphone-slash": () => import("./iconAssets/microphone-slash.js"),
    microphone: () => import("./iconAssets/microphone.js"),
    "minus-circle": () => import("./iconAssets/minus-circle.js"),
    minus: () => import("./iconAssets/minus.js"),
    "navigation-arrow": () => import("./iconAssets/navigation-arrow.js"),
    note: () => import("./iconAssets/note.js"),
    "paper-plane-right": () => import("./iconAssets/paper-plane-right.js"),
    "paper-plane-tilt": () => import("./iconAssets/paper-plane-tilt.js"),
    paperclip: () => import("./iconAssets/paperclip.js"),
    password: () => import("./iconAssets/password.js"),
    "pause-circle": () => import("./iconAssets/pause-circle.js"),
    pause: () => import("./iconAssets/pause.js"),
    "pencil-simple": () => import("./iconAssets/pencil-simple.js"),
    phone: () => import("./iconAssets/phone.js"),
    "play-circle": () => import("./iconAssets/play-circle.js"),
    play: () => import("./iconAssets/play.js"),
    "plus-circle": () => import("./iconAssets/plus-circle.js"),
    plus: () => import("./iconAssets/plus.js"),
    presentation: () => import("./iconAssets/presentation.js"),
    printer: () => import("./iconAssets/printer.js"),
    prohibit: () => import("./iconAssets/prohibit.js"),
    "push-pin-simple-slash": () => import("./iconAssets/push-pin-simple-slash.js"),
    "push-pin-simple": () => import("./iconAssets/push-pin-simple.js"),
    "push-pin-slash": () => import("./iconAssets/push-pin-slash.js"),
    "push-pin": () => import("./iconAssets/push-pin.js"),
    question: () => import("./iconAssets/question.js"),
    repeat: () => import("./iconAssets/repeat.js"),
    robot: () => import("./iconAssets/robot.js"),
    "seal-check": () => import("./iconAssets/seal-check.js"),
    "share-fat": () => import("./iconAssets/share-fat.js"),
    "share-network": () => import("./iconAssets/share-network.js"),
    share: () => import("./iconAssets/share.js"),
    "shopping-cart-simple": () => import("./iconAssets/shopping-cart-simple.js"),
    signature: () => import("./iconAssets/signature.js"),
    signout: () => import("./iconAssets/signout.js"),
    "sliders-horizontal": () => import("./iconAssets/sliders-horizontal.js"),
    sliders: () => import("./iconAssets/sliders.js"),
    "speaker-simple-high": () => import("./iconAssets/speaker-simple-high.js"),
    "speaker-simple-low": () => import("./iconAssets/speaker-simple-low.js"),
    "speaker-simple-none": () => import("./iconAssets/speaker-simple-none.js"),
    "speaker-simple-slash": () => import("./iconAssets/speaker-simple-slash.js"),
    "speaker-simple-x": () => import("./iconAssets/speaker-simple-x.js"),
    spinner: () => import("./iconAssets/spinner.js"),
    star: () => import("./iconAssets/star.js"),
    subtitles: () => import("./iconAssets/subtitles.js"),
    syringe: () => import("./iconAssets/syringe.js"),
    "tag-simple": () => import("./iconAssets/tag-simple.js"),
    "test-tube": () => import("./iconAssets/test-tube.js"),
    "text-align-center": () => import("./iconAssets/text-align-center.js"),
    "text-align-left": () => import("./iconAssets/text-align-left.js"),
    "text-align-right": () => import("./iconAssets/text-align-right.js"),
    "thermometer-cold": () => import("./iconAssets/thermometer-cold.js"),
    "thermometer-hot": () => import("./iconAssets/thermometer-hot.js"),
    "thermometer-simple": () => import("./iconAssets/thermometer-simple.js"),
    "thumbs-down": () => import("./iconAssets/thumbs-down.js"),
    "thumbs-up": () => import("./iconAssets/thumbs-up.js"),
    timer: () => import("./iconAssets/timer.js"),
    translate: () => import("./iconAssets/translate.js"),
    trash: () => import("./iconAssets/trash.js"),
    "tree-structure": () => import("./iconAssets/tree-structure.js"),
    truck: () => import("./iconAssets/truck.js"),
    "upload-simple": () => import("./iconAssets/upload-simple.js"),
    "user-circle": () => import("./iconAssets/user-circle.js"),
    "user-gear": () => import("./iconAssets/user-gear.js"),
    "user-minus": () => import("./iconAssets/user-minus.js"),
    "user-plus": () => import("./iconAssets/user-plus.js"),
    "user-switch": () => import("./iconAssets/user-switch.js"),
    user: () => import("./iconAssets/user.js"),
    "users-four": () => import("./iconAssets/users-four.js"),
    "users-three": () => import("./iconAssets/users-three.js"),
    users: () => import("./iconAssets/users.js"),
    virus: () => import("./iconAssets/virus.js"),
    warehouse: () => import("./iconAssets/warehouse.js"),
    "warning-circle": () => import("./iconAssets/warning-circle.js"),
    "warning-diamond": () => import("./iconAssets/warning-diamond.js"),
    "warning-octagon": () => import("./iconAssets/warning-octagon.js"),
    warning: () => import("./iconAssets/warning.js"),
    wrench: () => import("./iconAssets/wrench.js"),
    "x-circle": () => import("./iconAssets/x-circle.js"),
    "x-square": () => import("./iconAssets/x-square.js"),
    x: () => import("./iconAssets/x.js"),
    AD: () => import("../FlagIcon/iconAssets/AD.js"),
    AE: () => import("../FlagIcon/iconAssets/AE.js"),
    AF: () => import("../FlagIcon/iconAssets/AF.js"),
    AG: () => import("../FlagIcon/iconAssets/AG.js"),
    AI: () => import("../FlagIcon/iconAssets/AI.js"),
    AL: () => import("../FlagIcon/iconAssets/AL.js"),
    AM: () => import("../FlagIcon/iconAssets/AM.js"),
    AO: () => import("../FlagIcon/iconAssets/AO.js"),
    AR: () => import("../FlagIcon/iconAssets/AR.js"),
    AS: () => import("../FlagIcon/iconAssets/AS.js"),
    AT: () => import("../FlagIcon/iconAssets/AT.js"),
    AU: () => import("../FlagIcon/iconAssets/AU.js"),
    AW: () => import("../FlagIcon/iconAssets/AW.js"),
    AX: () => import("../FlagIcon/iconAssets/AX.js"),
    AZ: () => import("../FlagIcon/iconAssets/AZ.js"),
    BA: () => import("../FlagIcon/iconAssets/BA.js"),
    BB: () => import("../FlagIcon/iconAssets/BB.js"),
    BD: () => import("../FlagIcon/iconAssets/BD.js"),
    BE: () => import("../FlagIcon/iconAssets/BE.js"),
    BF: () => import("../FlagIcon/iconAssets/BF.js"),
    BG: () => import("../FlagIcon/iconAssets/BG.js"),
    BH: () => import("../FlagIcon/iconAssets/BH.js"),
    BI: () => import("../FlagIcon/iconAssets/BI.js"),
    BJ: () => import("../FlagIcon/iconAssets/BJ.js"),
    BL: () => import("../FlagIcon/iconAssets/BL.js"),
    BM: () => import("../FlagIcon/iconAssets/BM.js"),
    BN: () => import("../FlagIcon/iconAssets/BN.js"),
    BO: () => import("../FlagIcon/iconAssets/BO.js"),
    BR: () => import("../FlagIcon/iconAssets/BR.js"),
    BS: () => import("../FlagIcon/iconAssets/BS.js"),
    BT: () => import("../FlagIcon/iconAssets/BT.js"),
    BV: () => import("../FlagIcon/iconAssets/BV.js"),
    BW: () => import("../FlagIcon/iconAssets/BW.js"),
    BY: () => import("../FlagIcon/iconAssets/BY.js"),
    BZ: () => import("../FlagIcon/iconAssets/BZ.js"),
    CA: () => import("../FlagIcon/iconAssets/CA.js"),
    CC: () => import("../FlagIcon/iconAssets/CC.js"),
    CD: () => import("../FlagIcon/iconAssets/CD.js"),
    CF: () => import("../FlagIcon/iconAssets/CF.js"),
    CG: () => import("../FlagIcon/iconAssets/CG.js"),
    CH: () => import("../FlagIcon/iconAssets/CH.js"),
    CI: () => import("../FlagIcon/iconAssets/CI.js"),
    CK: () => import("../FlagIcon/iconAssets/CK.js"),
    CL: () => import("../FlagIcon/iconAssets/CL.js"),
    CM: () => import("../FlagIcon/iconAssets/CM.js"),
    CN: () => import("../FlagIcon/iconAssets/CN.js"),
    CO: () => import("../FlagIcon/iconAssets/CO.js"),
    CR: () => import("../FlagIcon/iconAssets/CR.js"),
    CU: () => import("../FlagIcon/iconAssets/CU.js"),
    CV: () => import("../FlagIcon/iconAssets/CV.js"),
    CW: () => import("../FlagIcon/iconAssets/CW.js"),
    CX: () => import("../FlagIcon/iconAssets/CX.js"),
    CY: () => import("../FlagIcon/iconAssets/CY.js"),
    CZ: () => import("../FlagIcon/iconAssets/CZ.js"),
    DE: () => import("../FlagIcon/iconAssets/DE.js"),
    DJ: () => import("../FlagIcon/iconAssets/DJ.js"),
    DK: () => import("../FlagIcon/iconAssets/DK.js"),
    DM: () => import("../FlagIcon/iconAssets/DM.js"),
    DO: () => import("../FlagIcon/iconAssets/DO.js"),
    DZ: () => import("../FlagIcon/iconAssets/DZ.js"),
    EC: () => import("../FlagIcon/iconAssets/EC.js"),
    EE: () => import("../FlagIcon/iconAssets/EE.js"),
    EG: () => import("../FlagIcon/iconAssets/EG.js"),
    ER: () => import("../FlagIcon/iconAssets/ER.js"),
    ES: () => import("../FlagIcon/iconAssets/ES.js"),
    ET: () => import("../FlagIcon/iconAssets/ET.js"),
    EU: () => import("../FlagIcon/iconAssets/EU.js"),
    FI: () => import("../FlagIcon/iconAssets/FI.js"),
    FJ: () => import("../FlagIcon/iconAssets/FJ.js"),
    FK: () => import("../FlagIcon/iconAssets/FK.js"),
    FM: () => import("../FlagIcon/iconAssets/FM.js"),
    FO: () => import("../FlagIcon/iconAssets/FO.js"),
    FR: () => import("../FlagIcon/iconAssets/FR.js"),
    GA: () => import("../FlagIcon/iconAssets/GA.js"),
    "GB-ENG": () => import("../FlagIcon/iconAssets/GB-ENG.js"),
    "GB-NIR": () => import("../FlagIcon/iconAssets/GB-NIR.js"),
    "GB-SCT": () => import("../FlagIcon/iconAssets/GB-SCT.js"),
    "GB-WLS": () => import("../FlagIcon/iconAssets/GB-WLS.js"),
    "GB-ZET": () => import("../FlagIcon/iconAssets/GB-ZET.js"),
    GB: () => import("../FlagIcon/iconAssets/GB.js"),
    GD: () => import("../FlagIcon/iconAssets/GD.js"),
    GE: () => import("../FlagIcon/iconAssets/GE.js"),
    GF: () => import("../FlagIcon/iconAssets/GF.js"),
    GG: () => import("../FlagIcon/iconAssets/GG.js"),
    GH: () => import("../FlagIcon/iconAssets/GH.js"),
    GI: () => import("../FlagIcon/iconAssets/GI.js"),
    GL: () => import("../FlagIcon/iconAssets/GL.js"),
    GM: () => import("../FlagIcon/iconAssets/GM.js"),
    GN: () => import("../FlagIcon/iconAssets/GN.js"),
    GP: () => import("../FlagIcon/iconAssets/GP.js"),
    GQ: () => import("../FlagIcon/iconAssets/GQ.js"),
    GR: () => import("../FlagIcon/iconAssets/GR.js"),
    GS: () => import("../FlagIcon/iconAssets/GS.js"),
    GT: () => import("../FlagIcon/iconAssets/GT.js"),
    GU: () => import("../FlagIcon/iconAssets/GU.js"),
    GW: () => import("../FlagIcon/iconAssets/GW.js"),
    GY: () => import("../FlagIcon/iconAssets/GY.js"),
    HK: () => import("../FlagIcon/iconAssets/HK.js"),
    HM: () => import("../FlagIcon/iconAssets/HM.js"),
    HN: () => import("../FlagIcon/iconAssets/HN.js"),
    HR: () => import("../FlagIcon/iconAssets/HR.js"),
    HT: () => import("../FlagIcon/iconAssets/HT.js"),
    HU: () => import("../FlagIcon/iconAssets/HU.js"),
    ID: () => import("../FlagIcon/iconAssets/ID.js"),
    IE: () => import("../FlagIcon/iconAssets/IE.js"),
    IL: () => import("../FlagIcon/iconAssets/IL.js"),
    IM: () => import("../FlagIcon/iconAssets/IM.js"),
    IN: () => import("../FlagIcon/iconAssets/IN.js"),
    IO: () => import("../FlagIcon/iconAssets/IO.js"),
    IQ: () => import("../FlagIcon/iconAssets/IQ.js"),
    IR: () => import("../FlagIcon/iconAssets/IR.js"),
    IS: () => import("../FlagIcon/iconAssets/IS.js"),
    IT: () => import("../FlagIcon/iconAssets/IT.js"),
    JE: () => import("../FlagIcon/iconAssets/JE.js"),
    JM: () => import("../FlagIcon/iconAssets/JM.js"),
    JO: () => import("../FlagIcon/iconAssets/JO.js"),
    JP: () => import("../FlagIcon/iconAssets/JP.js"),
    KE: () => import("../FlagIcon/iconAssets/KE.js"),
    KG: () => import("../FlagIcon/iconAssets/KG.js"),
    KH: () => import("../FlagIcon/iconAssets/KH.js"),
    KI: () => import("../FlagIcon/iconAssets/KI.js"),
    KM: () => import("../FlagIcon/iconAssets/KM.js"),
    KN: () => import("../FlagIcon/iconAssets/KN.js"),
    KP: () => import("../FlagIcon/iconAssets/KP.js"),
    KR: () => import("../FlagIcon/iconAssets/KR.js"),
    KW: () => import("../FlagIcon/iconAssets/KW.js"),
    KY: () => import("../FlagIcon/iconAssets/KY.js"),
    KZ: () => import("../FlagIcon/iconAssets/KZ.js"),
    LA: () => import("../FlagIcon/iconAssets/LA.js"),
    LB: () => import("../FlagIcon/iconAssets/LB.js"),
    LC: () => import("../FlagIcon/iconAssets/LC.js"),
    LGBT1: () => import("../FlagIcon/iconAssets/LGBT1.js"),
    LI: () => import("../FlagIcon/iconAssets/LI.js"),
    LK: () => import("../FlagIcon/iconAssets/LK.js"),
    LR: () => import("../FlagIcon/iconAssets/LR.js"),
    LS: () => import("../FlagIcon/iconAssets/LS.js"),
    LT: () => import("../FlagIcon/iconAssets/LT.js"),
    LU: () => import("../FlagIcon/iconAssets/LU.js"),
    LV: () => import("../FlagIcon/iconAssets/LV.js"),
    LY: () => import("../FlagIcon/iconAssets/LY.js"),
    MA: () => import("../FlagIcon/iconAssets/MA.js"),
    MC: () => import("../FlagIcon/iconAssets/MC.js"),
    MD: () => import("../FlagIcon/iconAssets/MD.js"),
    ME: () => import("../FlagIcon/iconAssets/ME.js"),
    MF: () => import("../FlagIcon/iconAssets/MF.js"),
    MG: () => import("../FlagIcon/iconAssets/MG.js"),
    MH: () => import("../FlagIcon/iconAssets/MH.js"),
    MK: () => import("../FlagIcon/iconAssets/MK.js"),
    ML: () => import("../FlagIcon/iconAssets/ML.js"),
    MM: () => import("../FlagIcon/iconAssets/MM.js"),
    MN: () => import("../FlagIcon/iconAssets/MN.js"),
    MO: () => import("../FlagIcon/iconAssets/MO.js"),
    MP: () => import("../FlagIcon/iconAssets/MP.js"),
    MQ: () => import("../FlagIcon/iconAssets/MQ.js"),
    MR: () => import("../FlagIcon/iconAssets/MR.js"),
    MS: () => import("../FlagIcon/iconAssets/MS.js"),
    MT: () => import("../FlagIcon/iconAssets/MT.js"),
    MU: () => import("../FlagIcon/iconAssets/MU.js"),
    MV: () => import("../FlagIcon/iconAssets/MV.js"),
    MW: () => import("../FlagIcon/iconAssets/MW.js"),
    MX: () => import("../FlagIcon/iconAssets/MX.js"),
    MY: () => import("../FlagIcon/iconAssets/MY.js"),
    MZ: () => import("../FlagIcon/iconAssets/MZ.js"),
    NA: () => import("../FlagIcon/iconAssets/NA.js"),
    NC: () => import("../FlagIcon/iconAssets/NC.js"),
    NE: () => import("../FlagIcon/iconAssets/NE.js"),
    NF: () => import("../FlagIcon/iconAssets/NF.js"),
    NG: () => import("../FlagIcon/iconAssets/NG.js"),
    NI: () => import("../FlagIcon/iconAssets/NI.js"),
    NL: () => import("../FlagIcon/iconAssets/NL.js"),
    NO: () => import("../FlagIcon/iconAssets/NO.js"),
    NP: () => import("../FlagIcon/iconAssets/NP.js"),
    NR: () => import("../FlagIcon/iconAssets/NR.js"),
    NU: () => import("../FlagIcon/iconAssets/NU.js"),
    NZ: () => import("../FlagIcon/iconAssets/NZ.js"),
    OM: () => import("../FlagIcon/iconAssets/OM.js"),
    PA: () => import("../FlagIcon/iconAssets/PA.js"),
    PE: () => import("../FlagIcon/iconAssets/PE.js"),
    PF: () => import("../FlagIcon/iconAssets/PF.js"),
    PG: () => import("../FlagIcon/iconAssets/PG.js"),
    PH: () => import("../FlagIcon/iconAssets/PH.js"),
    PK: () => import("../FlagIcon/iconAssets/PK.js"),
    PL: () => import("../FlagIcon/iconAssets/PL.js"),
    PM: () => import("../FlagIcon/iconAssets/PM.js"),
    PN: () => import("../FlagIcon/iconAssets/PN.js"),
    PR: () => import("../FlagIcon/iconAssets/PR.js"),
    PS: () => import("../FlagIcon/iconAssets/PS.js"),
    PT: () => import("../FlagIcon/iconAssets/PT.js"),
    PW: () => import("../FlagIcon/iconAssets/PW.js"),
    PY: () => import("../FlagIcon/iconAssets/PY.js"),
    QA: () => import("../FlagIcon/iconAssets/QA.js"),
    RE: () => import("../FlagIcon/iconAssets/RE.js"),
    RO: () => import("../FlagIcon/iconAssets/RO.js"),
    RS: () => import("../FlagIcon/iconAssets/RS.js"),
    RU: () => import("../FlagIcon/iconAssets/RU.js"),
    RW: () => import("../FlagIcon/iconAssets/RW.js"),
    SA: () => import("../FlagIcon/iconAssets/SA.js"),
    SB: () => import("../FlagIcon/iconAssets/SB.js"),
    SC: () => import("../FlagIcon/iconAssets/SC.js"),
    SD: () => import("../FlagIcon/iconAssets/SD.js"),
    SE: () => import("../FlagIcon/iconAssets/SE.js"),
    SG: () => import("../FlagIcon/iconAssets/SG.js"),
    SH: () => import("../FlagIcon/iconAssets/SH.js"),
    SI: () => import("../FlagIcon/iconAssets/SI.js"),
    SJ: () => import("../FlagIcon/iconAssets/SJ.js"),
    SK: () => import("../FlagIcon/iconAssets/SK.js"),
    SL: () => import("../FlagIcon/iconAssets/SL.js"),
    SM: () => import("../FlagIcon/iconAssets/SM.js"),
    SN: () => import("../FlagIcon/iconAssets/SN.js"),
    SO: () => import("../FlagIcon/iconAssets/SO.js"),
    SR: () => import("../FlagIcon/iconAssets/SR.js"),
    SS: () => import("../FlagIcon/iconAssets/SS.js"),
    ST: () => import("../FlagIcon/iconAssets/ST.js"),
    SV: () => import("../FlagIcon/iconAssets/SV.js"),
    SX: () => import("../FlagIcon/iconAssets/SX.js"),
    SY: () => import("../FlagIcon/iconAssets/SY.js"),
    SZ: () => import("../FlagIcon/iconAssets/SZ.js"),
    TC: () => import("../FlagIcon/iconAssets/TC.js"),
    TD: () => import("../FlagIcon/iconAssets/TD.js"),
    TF: () => import("../FlagIcon/iconAssets/TF.js"),
    TG: () => import("../FlagIcon/iconAssets/TG.js"),
    TH: () => import("../FlagIcon/iconAssets/TH.js"),
    TJ: () => import("../FlagIcon/iconAssets/TJ.js"),
    TK: () => import("../FlagIcon/iconAssets/TK.js"),
    TL: () => import("../FlagIcon/iconAssets/TL.js"),
    TM: () => import("../FlagIcon/iconAssets/TM.js"),
    TN: () => import("../FlagIcon/iconAssets/TN.js"),
    TO: () => import("../FlagIcon/iconAssets/TO.js"),
    TR: () => import("../FlagIcon/iconAssets/TR.js"),
    TT: () => import("../FlagIcon/iconAssets/TT.js"),
    TV: () => import("../FlagIcon/iconAssets/TV.js"),
    TW: () => import("../FlagIcon/iconAssets/TW.js"),
    TZ: () => import("../FlagIcon/iconAssets/TZ.js"),
    UA: () => import("../FlagIcon/iconAssets/UA.js"),
    UG: () => import("../FlagIcon/iconAssets/UG.js"),
    UM: () => import("../FlagIcon/iconAssets/UM.js"),
    US: () => import("../FlagIcon/iconAssets/US.js"),
    USCA: () => import("../FlagIcon/iconAssets/USCA.js"),
    UY: () => import("../FlagIcon/iconAssets/UY.js"),
    UZ: () => import("../FlagIcon/iconAssets/UZ.js"),
    VA: () => import("../FlagIcon/iconAssets/VA.js"),
    VC: () => import("../FlagIcon/iconAssets/VC.js"),
    VE: () => import("../FlagIcon/iconAssets/VE.js"),
    VG: () => import("../FlagIcon/iconAssets/VG.js"),
    VI: () => import("../FlagIcon/iconAssets/VI.js"),
    VN: () => import("../FlagIcon/iconAssets/VN.js"),
    VU: () => import("../FlagIcon/iconAssets/VU.js"),
    WF: () => import("../FlagIcon/iconAssets/WF.js"),
    WS: () => import("../FlagIcon/iconAssets/WS.js"),
    XK: () => import("../FlagIcon/iconAssets/XK.js"),
    YE: () => import("../FlagIcon/iconAssets/YE.js"),
    YT: () => import("../FlagIcon/iconAssets/YT.js"),
    ZA: () => import("../FlagIcon/iconAssets/ZA.js"),
    ZM: () => import("../FlagIcon/iconAssets/ZM.js"),
    ZW: () => import("../FlagIcon/iconAssets/ZW.js")
};
const loadIcon = (componentName) => {
    return react_1.default.lazy(() => exports.IconImports[componentName]().then((module) => ({
        default: Object.values(module).at(0)
    })));
};
exports.loadIcon = loadIcon;
//# sourceMappingURL=IconImports.js.map